import type { CopyShape } from "@tami/core/intl";

import type { DEMO_ORG_MODE_SWITCH_COPY_PT_BR } from "../demo-org-mode-switch.copy";

export const DEMO_ORG_MODE_SWITCH_COPY_ES_ES: CopyShape<typeof DEMO_ORG_MODE_SWITCH_COPY_PT_BR> = {
  ariaLabel: "Elige el tipo de cuenta en la demo",
  creator: {
    label: "Soy Creator",
    shortLabel: "Creator",
    hint: "Tú y tus redes",
  },
  collab: {
    label: "Soy Collab",
    shortLabel: "Collab",
    hint: "Tú y tu cartera de creators",
  },
};
